<template>
  <div class="index-box">
    <header>
      <span class="search-bar" @click="search">{{ $t("index.search") }}</span>
      <messageBtn></messageBtn>
    </header>
    <push-message></push-message>
    <section>
      <download-app v-if="downloadState"></download-app>
      <swiper-banner></swiper-banner>
      <!-- 年度学习报告 -->
      <report-year2020></report-year2020>
      <mid-nav
        :menuArray="menuArray"
        v-show="menuArray.length"
        class="nav-bar"
      ></mid-nav>
      <today-study></today-study>
      <div
        class="module-cell"
        v-for="(item, index) in homeModules"
        :key="index"
      >
        <!-- 直播模块 -->
        <div v-if="item.tag == 'liveBroadcast' && item.is_checked == 1">
          <on-air ref="living"></on-air>
        </div>
        <today-comment
          v-else-if="item.tag == 'learnMap'"
          :showModule="item.child"
        ></today-comment>
        <!-- 学习项目模块 -->
        <div v-else-if="item.tag == 'learnProject' && item.is_checked == 1">
          <!--  -->
          <study-online-tab2
            :programs="programs"
            :item_programs="item_programs"
          ></study-online-tab2>
        </div>
        <!-- 选修库 -->
        <elective-lib
          v-if="item.tag == 'option' && item.is_checked == 1"
        ></elective-lib>
        <!-- 专栏模块 -->
        <div v-else-if="item.tag == 'column' && item.is_checked == 1">
          <!-- 文章 -->
          <!-- <article-box></article-box> -->
          <!-- 音频 -->
          <!-- <audio-box></audio-box> -->
          <!-- 视频 -->
          <video-box></video-box>
        </div>
        <!-- 培训计划模块 必修和选修 -->
        <div v-else-if="item.tag == 'trainplan'">
          <template
            v-if="
              item.child[0].is_checked == 1 && item.child[1].is_checked == 1
            "
          >
            <study-online-tab
              :requires="requires"
              :electives="electives"
              :item_requires="item_requires"
              :item_electives="item_electives"
            ></study-online-tab>
          </template>
          <template
            v-else-if="
              item.child[0].is_checked == 1 && item.child[1].is_checked == 0
            "
          >
            <study-online-tab3
              :requires="requires"
              :item_requires="item_requires"
            ></study-online-tab3>
          </template>
          <template
            v-else-if="
              item.child[0].is_checked == 0 && item.child[1].is_checked == 1
            "
          >
            <study-online-tab4
              :electives="electives"
              :item_electives="item_electives"
            ></study-online-tab4>
          </template>
        </div>
      </div>
    </section>
    <dakaBtn class="dakaBtn"></dakaBtn>
    <Footer></Footer>
  </div>
</template>
<script>
import SwiperBanner from "components/SwiperBanner.vue";
import MidNav from "components/MidNav.vue";
import pushMessage from "@/components/message/messagePush";
import StudyOnline from "views/studyonline/StudyOnline.vue";
import StudyOnline2 from "views/studyonline/StudyOnline2.vue";
import StudyOnline3 from "views/studyonline/StudyOnline3.vue";
import StudyOnline4 from "views/studyonline/StudyOnline4.vue";
import OnAir from "@/components/OnAir.vue";
import Video from "views/column_video/column_video";
import electiveLib from "@/components/indexElective";
// import Article from "views/article/Article.vue";
import Footer from "components/Footer.vue";
// import Audio from "views/audio/Audio.vue";
import dakaBtn from "views/daka/daka_index_btn.vue";
import messageBtn from "components/message/message_index_btn.vue";
import todayStudy from "./365course/todayStudy";
import todayComment from "./365course/todayComment";
import downloadApp from "@/components/downloadApp";
import reportYear2020 from "views/report_year";

export default {
  name: "Index",
  data() {
    return {
      // details: [],
      homeModules: [],
      menuArray: [],
      requires: [], // 必修
      item_requires: [],
      electives: [], // 选修
      item_electives: [],
      programs: [], // 项目
      item_programs: [],
      repeat1: 0,
      repeat2: 0,
      // 下载APP显示状态
      downloadState: false,
    };
  },
  components: {
    "swiper-banner": SwiperBanner,
    // 'swiper-banner2': SwiperBanner2,
    "study-online-tab": StudyOnline,
    "study-online-tab2": StudyOnline2,
    "study-online-tab3": StudyOnline3,
    "study-online-tab4": StudyOnline4,
    OnAir,
    "video-box": Video,
    // "article-box": Article,
    "mid-nav": MidNav,
    Footer,
    electiveLib,
    // "audio-box": Audio,
    dakaBtn,
    messageBtn,
    todayStudy,
    todayComment,
    downloadApp,
    pushMessage,
    reportYear2020,
  },
  // computed: {
  //   ...mapState(["message"])
  // },
  activated() {
    // 模块加载
    if (this.repeat1 == 1) {
      this.getMoudlesDate();
    }
    // 学习项目，必修，选修
    if (this.repeat2 == 1) {
      this.get_trainplan_list();
    }
    // 直播列表重新加载
    if (this.$refs.living != undefined) {
      this.$refs.living[0].getLivingList();
    }
  },
  mounted() {
    this.getMoudlesDate();
    this.get_trainplan_list();
  },
  methods: {
    getMoudlesDate() {
      let url = "index.php/mobile/index/modules";
      let data = {};
      this.$axios.post(url, data).then((res) => {
        this.repeat1 = 1;
        if (res.data.code == 0) {
          this.homeModules = res.data.result.home_modules;
          // this.menuArray = res.data.result.modules.split(",");
          this.menuArray = res.data.result.nav_modules || [];
          if (
            res.data.result.modules &&
            res.data.result.modules.includes("downloadApp")
          ) {
            this.downloadState = true;
          }
          localStorage._platform_have_modules = res.data.result.modules;
          localStorage._platform_other_modules = res.data.result.other_modules;
          this.$store.commit(
            "collect/increment",
            res.data.result.modules.split(",")
          );
        }
      });
    },
    search() {
      this.$store.commit("changeWord", "");
      this.$store.commit("changeNav", 0);
      this.$router.push("/searchIndex");
    },
    get_trainplan_list() {
      let url = "index.php/mobile/index/my-trainplan-list";
      let params = {
        sys_id: localStorage.getItem("_sys_id"),
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        language: localStorage.getItem("_user_data_language"),
      };
      this.$axios.post(url, params).then((res) => {
        this.repeat2 = 1;
        // console.log("222", res);
        if (res.data.code == 0) {
          this.requires = res.data.result.requires; // 必修
          if (this.requires != undefined) {
            for (var i = 0; i < this.requires.length; i++) {
              if (this.requires[i].finish_progress == 100) {
                // 已完成
                this.requires[i].message = {
                  whichShow: 1,
                  limitDays: -1,
                  mask: false,
                };
              } else if (this.requires[i].is_overdue == 1) {
                // 已过期
                this.requires[i].message = {
                  whichShow: 4,
                  limitDays: -1,
                  mask: true,
                };
              } else if (this.requires[i].tag_bottom) {
                // 剩
                this.requires[i].message = {
                  whichShow: 3,
                  limitDays: this.requires[i].tag_bottom,
                  mask: false,
                };
              } else {
                // 未完成
                this.requires[i].message = {
                  whichShow: 2,
                  limitDays: -1,
                  mask: false,
                };
              }
            }
          } else {
            this.requires = {};
          }

          this.item_requires = this.requires;
          this.electives = res.data.result.electives; // 选修
          for (let i = 0; i < this.electives.length; i++) {
            if (this.electives[i].finish_progress == 100) {
              // 已完成
              this.electives[i].message = {
                whichShow: 1,
                limitDays: -1,
                mask: false,
              };
            } else if (this.electives[i].is_overdue == 1) {
              // 已过期
              this.electives[i].message = {
                whichShow: 4,
                limitDays: -1,
                mask: true,
              };
            } else if (this.electives[i].tag_bottom) {
              // 剩
              this.electives[i].message = {
                whichShow: 3,
                limitDays: this.electives[i].tag_bottom,
                mask: false,
              };
            } else {
              // 未完成
              this.electives[i].message = {
                whichShow: 2,
                limitDays: -1,
                mask: false,
              };
            }
          }
          this.item_electives = this.electives;
          this.programs = res.data.result.programs; // 项目
          for (let i = 0; i < this.programs.length; i++) {
            if (this.programs[i].finish_progress == 100) {
              // 已完成
              this.programs[i].message = {
                whichShow: 1,
                limitDays: -1,
                mask: false,
              };
            } else if (this.programs[i].is_overdue == 1) {
              // 已过期
              this.programs[i].message = {
                whichShow: 4,
                limitDays: -1,
                mask: true,
              };
            } else if (
              this.programs[i].left_days > 0 &&
              this.programs[i].left_days <= 15
            ) {
              // 剩
              this.programs[i].message = {
                whichShow: 3,
                limitDays: this.programs[i].left_days,
              };
            } else {
              // 未完成
              this.programs[i].message = {
                whichShow: 2,
                limitDays: -1,
                mask: false,
              };
            }
          }
          this.item_programs = this.programs;
        }
        // 隐私政策
        this.privacyAgreeCheck(params);
      });
    },
  },
  // 修改列表页的meta值，false时再次进入页面会重新请求数据。
  beforeRouteLeave(to, from, next) {
    // to.meta.keepAlive = false;
    if (to.name == "columnVideoList") {
      this.$store.commit("column_video/fromid", to.query.id);
    }
    // to.meta.isBack = false;
    next();
  },
};
</script>
<style scoped lang="less">
.index-box {
  position: relative;
  width: 100%;
  padding-bottom: 1.1rem;
  header {
    position: fixed;
    top: 0;
    left: 0;
    height: 0.86rem;
    line-height: 0.86rem;
    width: 100%;
    font-size: 0.16rem;
    background: #f6f6f6;
    z-index: 100;
    .search-bar {
      float: left;
      display: block;
      background: white;
      color: #b5b5b5;
      font-size: 0.24rem;
      width: 6.06rem;
      height: 0.5rem;
      margin: 0.18rem 0.22rem;
      border-radius: 0.43rem;
      line-height: 0.5rem;
      padding-left: 0.28rem;
    }
  }
  section {
    width: 100%;
    margin-top: 0.86rem;
    background: #eeeeee;
    .nav-bar {
      margin-bottom: 0.2rem;
    }
    .module-cell {
      margin-bottom: 0.22rem;
      h4 {
        color: #666666;
        height: 0.72rem;
        line-height: 0.72rem;
        font-size: 0.28rem;
        text-align: center;
        background: #fff;
        span {
          margin: 0 0.1rem;
          position: relative;
          &:before {
            .modified-line;
            left: -0.3rem;
          }
          &:after {
            .modified-line;
            right: -0.3rem;
          }
        }
      }
    }
  }
  .dakaBtn {
    position: fixed;
    right: 0;
    bottom: 2rem;
    z-index: 99;
  }
}
.modified-line {
  content: "";
  position: absolute;
  top: 50%;
  width: 0.22rem;
  height: 0.02rem;
  background: #666;
}
.living-wrap {
  height: 6.2rem;
  overflow: hidden;
}
</style>
